import React, { useContext } from 'react';
import 'twin.macro';
import { AppContext } from '../context';
import { Icon } from '../icon';
import { LinkIcon, ShareIcon } from 'icons';
import { navigatorShareIsSupported } from '../common/hooks';
import { CopyUrl } from '../actions';
import { SoundBoardMobileButton } from '../soundboard';
import { gaEvent } from 'services/ga';
import { DropDown, DropDownItem } from '../dropdown';
import { socialSharingList, socialLinksList } from '../../data';

const itemUrl = (path) => `https://www.dumpert.nl${path}`;

export const NavigatorSharing = ({ title = '', itemUrl = '' }) => {
  const sharingIsSupported = navigatorShareIsSupported();

  const navigatorShare = () => {
    if (!sharingIsSupported) {
      return;
    }
    const encodeSharingText = `Check '${title}' op Dumpert`;
    navigator.share({
      title: 'Dumpert',
      text: encodeSharingText,
      url: itemUrl,
    });
  };

  return (
    <div onClick={() => navigatorShare()} tw='flex justify-center items-center cursor-pointer'>
      <Icon Type={ShareIcon} />
    </div>
  );
};

export const SocialSharing = ({ item, title = '', path = '', isRight }) => {
  const { windowSize } = useContext(AppContext);
  const sharingIsSupported =
    navigatorShareIsSupported() && ['MOBILE'].includes(windowSize.adBreakPoint);
  return (
    <>
      {/* mobile with sharing */}
      {sharingIsSupported && (
        <NavigatorSharing title={item ? item.title : title} itemUrl={itemUrl(path)} />
      )}
      {!sharingIsSupported && (
        <DropDown
          label='delen'
          iconProps={{ Type: ShareIcon }}
          buttonProps={{ secondary: true }}
          hideLabel={['MOBILE'].includes(windowSize.adBreakPoint)}
          isRight={isRight}
        >
          <DropDownItem IconType={LinkIcon} iconColor='icons'>
            <CopyUrl path={path} />
          </DropDownItem>
          {socialSharingList({ title, itemUrl: itemUrl(path) }).map((item, index) => (
            <DropDownItem key={index} IconType={item.icon} iconColor='icons'>
              <a
                href={item.url}
                target='_blank'
                rel='noopener noreferrer'
                aria-label={`'Link delen op ${item.label}`}
                id={`${item.label}-share`}
                tw='flex items-center justify-between capitalize'
                onClick={() => gaEvent('dmp_detail_page', 'share_' + item.label)}
              >
                {item.label}
              </a>
            </DropDownItem>
          ))}
        </DropDown>
      )}
    </>
  );
};

export const SocialLinks = ({ list, ...restProps }) => {
  return (
    <ul
      tw='list-none flex flex-wrap justify-between items-center w-full gap-3 md:gap-4'
      {...restProps}
    >
      {socialLinksList.map(({ label, url, icon }) => (
        <li key={label}>
          <a
            href={url}
            target='_blank'
            rel='noopener noreferrer'
            aria-label={`Dumpert op ${label}`}
            id={label + '-link'}
            tw='transition-all hover:opacity-75 hover:scale-110 active:scale-95'
            onClick={() => gaEvent('dmp_detail_page', label)}
          >
            <Icon Type={icon} />
          </a>
        </li>
      ))}
      <li>
        <SoundBoardMobileButton />
      </li>
    </ul>
  );
};
